import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative flex items-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons text-warmgray-900 text-opacity-60 block" }, "menu", -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "w-full items-center h-10 font-montserrat text-2xl z-30 mt-2 pt-1" }
const _hoisted_5 = { class: "fixed top-0 left-0 z-50 flex h-screen w-screen" }
const _hoisted_6 = { class: "bg-warmgray-100 flex w-64 flex-col bg-white shadow" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_MenuList = _resolveComponent("MenuList")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleMenu())),
        class: "inline-flex h-12 w-14 pt-1 flex-shrink-0 cursor-pointer items-center justify-center absolute z-40"
      }, _hoisted_3),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_router_link, { to: "/" }, {
          default: _withCtx(() => [
            _createTextVNode("InstaGraph")
          ]),
          _: 1
        })
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_MenuList, {
            onCloseMenu: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleMenu()))
          })
        ]),
        _createElementVNode("div", {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleMenu())),
          class: "flex-1 cursor-pointer bg-black bg-opacity-40"
        })
      ], 512), [
        [_vShow, _ctx.menu]
      ])
    ])
  ]))
}